import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Group from '@spa/shared/components/Filters/Group';
import TenantCounter from '@spa/shared/components/Filters/TenantCounter';
import { PeopleIcon, useMedia } from '@spa/shared';
import { GUESTS } from '@spa/shared/constants/tenantTypes';

const minGuests = 1;
const maxGuests = 12;
const Icon = <PeopleIcon width={20} />;

const Tenants = ({ fields, onMultiChangeHandler }) => {
  const { t } = useTranslation('translations');
  const { is } = useMedia();

  const onGuestsChangeHandler = useCallback(
    (name, value) => {
      onMultiChangeHandler({
        [name]: value
      });
    },
    [onMultiChangeHandler]
  );

  return (
    <Group hasTitle={is.mobile} title={t('filters.sections.set_people')}>
      <TenantCounter
        icon={Icon}
        min={minGuests}
        max={maxGuests}
        value={fields[GUESTS]}
        onChange={onGuestsChangeHandler}
        labelTranslation="filters.label.number_of_tenants"
      />
    </Group>
  );
};

Tenants.propTypes = {
  fields: PropTypes.object.isRequired,
  onMultiChangeHandler: PropTypes.func.isRequired
};

export default Tenants;
